import { defineService } from '@wix/services-manager/helpers'
import type { ServiceDefinition } from '@wix/services-manager/types'
import type { Context } from '@wix/thunderbolt-becky-types'

export interface IContextProviderService {
	/**
	 * returns a list of contexts attached to the provided component, ordered from the outside layer (with no dependencies)
	 * to the inner layer (most dependent or just dependent on the above layer)
	 */
	getAttachedContexts: (compId: string) => Array<Context>
	subscribeToContextChanges: (compId: string, callback: () => void) => () => void
}

export type IContextProviderServiceConfig = {
	compIdToContextsMap: {
		[compId: string]: Array<Context>
	}
}

export type IContextProviderServiceDefinition = ServiceDefinition<
	IContextProviderService,
	IContextProviderServiceConfig
>

export const ContextProviderServiceDefinition = defineService<IContextProviderService, IContextProviderServiceConfig>(
	'feature-builder-context-providers/context-provider-service'
)
